import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import axios, {AxiosError} from 'axios'

import {LatestSampledEquipment} from '../../../types'

const LatestSampleQueryKey = 'get-latest-sample'
export const useGetLatestSampledEquipment = (plantId: string) => {
  return useQuery<LatestSampledEquipment | undefined, AxiosError>({
    queryKey: [LatestSampleQueryKey, plantId],
    queryFn: async () => {
      const path = `/kpi-result/${plantId}/material-quality/latest-sample`
      try {
        const response = await ApiClient.axiosInstance.get<LatestSampledEquipment>(path)
        return response.data
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          return undefined
        }
        throw error
      }
    }
  })
}
